import axios from "../http";

class RentalIncome {
  //场租收入导入
  postRentalIncomeExcel(data) {
    const url = "/zwy/api/upload/rent";
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //场租预计导入
  postRentalEstimateExcel(data) {
    const url = "/zwy/api/upload/rent/expect";
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //场租收入手动填写
  getRentActually(warehouseId, reportDate, rentArea, rentCost) {
    const url = `/zwy/api/rent/actually?warehouseId=${warehouseId}&reportDate=${reportDate}&rentArea=${rentArea}&rentCost=${rentCost}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //其他收入上传
  postOtherIncomeExcel(data) {
    const url = "/zwy/api/upload/operator/other";
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //入库单导入
  postWarehousingEntryExcel(data) {
    const url = "/zwy/api/upload/stock/record";
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //按体积计算场租
  getCalculationRentalCosts(warehouseId) {
    const url = `/zwy/api/rent/calculate?warehouseId=${warehouseId}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //导入历史库存单
  postStockExcel(data) {
    const url = "/zwy/api/upload/stock/history";
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 获取历史库存单录入情况
  getStockRecord(warehouseId, date) {
    const url = `/zwy/api/rent/date/infos?warehouseId=${warehouseId}&date=${date}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default RentalIncome;
